/*
  variant-hero-switch.js
  - Farbwechsel: Klick auf eine Farboption zeigt sofort das passende Muster/Material
    (echtes Galeriebild -> Material-/Stoffbild-Overlay -> grosse Farbflaeche-Overlay).
  - Galerie-Aufraeumen: In der Thumbnail-Galerie erscheinen nur das freigestellte
    Bild (als Hero/erstes Bild) und Lifestyle-Bilder. Alle Farb-/Materialkacheln und
    ueberzaehlige freigestellte Bilder werden ausgeblendet (nicht geloescht).
*/
(function () {
  var STYLE_ID = 'hero-swatch-style';

  function injectStyle() {
    if (document.getElementById(STYLE_ID)) return;
    var css =
      '.hero-swatch-overlay{position:absolute;top:0;left:0;right:0;z-index:3;' +
      'background:#EEEEEC;display:flex;align-items:center;justify-content:center;' +
      'overflow:hidden;pointer-events:none;}' +
      '.hero-swatch-overlay[hidden]{display:none;}' +
      '.hero-swatch-overlay__img{max-width:100%;max-height:100%;width:100%;height:100%;object-fit:cover;display:block;}' +
      '.hero-swatch-overlay__fill{width:100%;height:100%;display:flex;align-items:flex-end;' +
      'justify-content:center;padding:2.4rem;box-sizing:border-box;}' +
      '.hero-swatch-overlay__name{font-size:1.6rem;letter-spacing:.04rem;color:#fff;' +
      'background:rgba(0,0,0,.45);padding:.7rem 1.4rem;border-radius:999px;line-height:1.2;}';
    var s = document.createElement('style');
    s.id = STYLE_ID;
    s.textContent = css;
    document.head.appendChild(s);
  }

  function esc(s) {
    return (s || '').replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }

  function normalize(s) {
    return (s || '').toLowerCase().replace(/nr\.?\s*/g, '').replace(/\s+/g, ' ').trim();
  }

  function getViewer(gallery) {
    return gallery.querySelector('[id^="GalleryViewer"]') || gallery;
  }

  function activeSlide(gallery) {
    return (
      gallery.querySelector('[id^="GalleryViewer"] .is-active[data-media-id]') ||
      gallery.querySelector('[id^="GalleryViewer"] [data-media-id]')
    );
  }

  function ensureOverlay(gallery) {
    var viewer = getViewer(gallery);
    var overlay = viewer.querySelector(':scope > .hero-swatch-overlay');
    if (overlay) return overlay;
    if (getComputedStyle(viewer).position === 'static') viewer.style.position = 'relative';
    overlay = document.createElement('div');
    overlay.className = 'hero-swatch-overlay';
    overlay.hidden = true;
    viewer.appendChild(overlay);
    return overlay;
  }

  function syncHeight(gallery, overlay) {
    var slide = activeSlide(gallery);
    if (!slide) return;
    var h = slide.getBoundingClientRect().height;
    if (h > 0) overlay.style.height = h + 'px';
  }

  function hideOverlay(overlay) {
    overlay.hidden = true;
    overlay.innerHTML = '';
  }

  // Alt-Text-Muster fuer Farb-/Materialkacheln (NICHT freigestellt).
  // Nur EINDEUTIGE Swatch-/Kachel-Begriffe. Material-/Stoffnamen wie "batyline",
  // "acryltuch", "bespannung", "sitzpolster" NICHT aufnehmen: diese stehen auch in
  // echten Produkt-/Lifestyle-Bildern (Alt-Text UND Dateiname) und wuerden dort
  // falsch ausblenden. Echte Farbkacheln tragen "…farbe", "kachel", "muster" o. Ae.
  var MAT_RE = /gestellfarbe|plattenfarbe|stofffarbe|stoffarbe|farbkachel|materialmuster|farbmuster|kachel|bespannung|sitzpolster/;
  var FREI_RE = /freigestellt|freisteller/;
  // Dateiname-Muster fuer Muster-/Materialbilder (falls kein Alt-Text vorhanden).
  var FILE_RE = /gestellfarbe|stofffarbe|stoffarbe|plattenfarbe|farbkachel|materialmuster|farbmuster|_stoffe_|swatch|muster/;
  // Dateiname-/Alt-Muster fuer freigestellte Produktfotos (weisser/grauer Hintergrund).
  // Bewusst spezifisch, damit echte Lifestyle-Bilder NICHT getroffen werden.
  var FREI_FILE_RE = /freigestellt|freisteller|packshot|weisser?[-_ ]?hintergrund|grauer?[-_ ]?hintergrund|white[-_ ]?bg|grey[-_ ]?bg|gray[-_ ]?bg/;

  function collectValueNames(pi) {
    var set = {};
    var inputs = pi.querySelectorAll('[data-value-name]');
    for (var i = 0; i < inputs.length; i++) {
      var n = normalize(inputs[i].getAttribute('data-value-name'));
      if (n) set[n] = true;
    }
    return set;
  }

  // Endet der (normalisierte) Alt-Text mit einem Options-Wertnamen? Dann ist es eine
  // Farb-/Materialkachel wie "… Bespannung Spring 16" oder "… Custom gepolstert in Natur 01".
  // Nur Wertnamen ab 5 Zeichen und mit Wortgrenze, damit Lifestyle-Alts nicht faelschlich
  // getroffen werden ("… mit Acryl Taupe" endet NICHT auf den Wert "taupe 83").
  function endsWithValueName(altN, valueNames) {
    if (!altN) return false;
    for (var k in valueNames) {
      if (k.length < 5) continue;
      if (altN === k || altN.slice(-(k.length + 1)) === ' ' + k) return true;
    }
    return false;
  }

  function isMaterialSlide(li, valueNames) {
    var img = li.querySelector('img');
    var altRaw = (img && img.getAttribute('alt')) || '';
    var altL = altRaw.toLowerCase();
    // Freigestellte Produktbilder sind NIE Materialkacheln (auch wenn der Alt-Text einen
    // Stoffnamen enthaelt, z. B. "… mit Batyline Iso – freigestellt").
    if (FREI_RE.test(altL)) return false;
    if (MAT_RE.test(altL)) return true;
    var altN = normalize(altRaw);
    if (altN && valueNames[altN]) return true;
    if (endsWithValueName(altN, valueNames)) return true;
    var src = (img && (img.getAttribute('src') || img.getAttribute('data-src') || img.currentSrc)) || '';
    var fn = src.split('?')[0].split('/').pop().toLowerCase();
    if (fn && FILE_RE.test(fn)) return true;
    return false;
  }

  // Freigestelltes Produktfoto? Erkennung ueber Alt-Text ODER Dateiname (weisser/grauer
  // Hintergrund, "freigestellt"/"freisteller"/"packshot"). Bewusst streng gefasst, damit
  // echte Lifestyle-Bilder nicht faelschlich ausgeblendet werden.
  function isFreigestellt(li) {
    var img = li.querySelector('img');
    var altL = ((img && img.getAttribute('alt')) || '').toLowerCase();
    if (FREI_RE.test(altL)) return true;
    var src = (img && (img.getAttribute('src') || img.getAttribute('data-src') || img.currentSrc)) || '';
    var fn = src.split('?')[0].split('/').pop().toLowerCase();
    if (fn && FREI_FILE_RE.test(fn)) return true;
    return false;
  }

  // Materialkacheln + ueberzaehlige freigestellte Bilder ausblenden. Bild 1
  // (freigestellt) bleibt Hero. Aktives Bild wird nie ausgeblendet.
  function cleanGallery(gallery, pi) {
    var viewer = getViewer(gallery);
    var slides = viewer.querySelectorAll('[data-media-id]');
    if (!slides.length) return { heroId: null };
    var valueNames = collectValueNames(pi);
    var hiddenIds = {};
    var visible = 0;
    var freiId = null;
    var lifeId = null;
    var seenFrei = false;
    for (var i = 0; i < slides.length; i++) {
      var li = slides[i];
      var isActive = li.classList.contains('is-active');
      var hide = false;
      if (isMaterialSlide(li, valueNames)) {
        hide = true;
      } else if (isFreigestellt(li)) {
        if (seenFrei) hide = true;
        else { seenFrei = true; if (!freiId) freiId = li.dataset.mediaId; }
      } else {
        if (!lifeId) lifeId = li.dataset.mediaId;
      }
      if (hide && !isActive) {
        li.style.display = 'none';
        hiddenIds[li.dataset.mediaId] = true;
      } else {
        li.style.display = '';
        visible++;
      }
    }
    // Thumbnails ausblenden: entweder das zugehoerige Slide wurde ausgeblendet
    // ODER das Thumbnail selbst ist eine Materialkachel (Dawn rendert teils
    // "verwaiste" Thumbnails ohne passendes Viewer-Slide).
    var thumbs = gallery.querySelectorAll('[id^="GalleryThumbnails"] [data-target]');
    var visThumbs = 0;
    for (var t = 0; t < thumbs.length; t++) {
      var th = thumbs[t];
      // Ueberzaehlige freigestellte Thumbnails (z. B. je Farbe "… freigestellt")
      // ausblenden – nur das Hero-freigestellte Bild bleibt. Greift auch bei
      // "verwaisten" Thumbnails ohne eigenes Viewer-Slide.
      var extraFrei = freiId && isFreigestellt(th) && th.dataset.target !== freiId;
      var hid = hiddenIds[th.dataset.target] || isMaterialSlide(th, valueNames) || extraFrei;
      th.style.display = hid ? 'none' : '';
      if (!hid) visThumbs++;
    }
    var total = gallery.querySelector('.slider-counter--total');
    if (total) total.textContent = visThumbs || visible;
    return { heroId: freiId || lifeId, valueNames: valueNames };
  }

  // Falls Dawn ein ausgeblendetes Bild aktiv schaltet, wieder einblenden.
  function revealActive(gallery) {
    var viewer = getViewer(gallery);
    var act = viewer.querySelector('.is-active[data-media-id]');
    if (act && act.style.display === 'none') act.style.display = '';
  }

  function findMediaByAlt(gallery, name) {
    if (!name) return null;
    var n = normalize(name);
    var items = gallery.querySelectorAll('[id^="GalleryViewer"] [data-media-id]');
    for (var i = 0; i < items.length; i++) {
      var img = items[i].querySelector('img');
      var alt = normalize((img && img.getAttribute('alt')) || '');
      if (alt && alt === n) return items[i].dataset.mediaId;
    }
    return null;
  }

  function applyHero(pi, gallery, overlay, input) {
    var name = (input.dataset.valueName || '').trim();
    var heroImage = input.dataset.heroImage;
    var heroColor = input.dataset.heroColor;

    var mediaId = findMediaByAlt(gallery, name);
    if (mediaId) {
      hideOverlay(overlay);
      pi._heroLast = { type: 'media', mediaId: mediaId };
      try { gallery.setActiveMedia(mediaId, false); } catch (e) {}
      revealActive(gallery);
      return;
    }
    if (heroImage) {
      overlay.innerHTML = '<img class="hero-swatch-overlay__img" src="' + esc(heroImage) + '" alt="' + esc(name) + '">';
      overlay.hidden = false;
      syncHeight(gallery, overlay);
      pi._heroLast = { type: 'overlay' };
      return;
    }
    if (heroColor) {
      // Grosse Farbflaeche: fuellt den kompletten Medienrahmen, Farbname als Label.
      overlay.innerHTML =
        '<div class="hero-swatch-overlay__fill" style="background:' + esc(heroColor) + '">' +
        (name ? '<span class="hero-swatch-overlay__name">' + esc(name) + '</span>' : '') +
        '</div>';
      overlay.hidden = false;
      syncHeight(gallery, overlay);
      pi._heroLast = { type: 'overlay' };
      return;
    }
    hideOverlay(overlay);
    pi._heroLast = null;
  }

  function setHero(gallery, pi) {
    var res = cleanGallery(gallery, pi);
    if (!res.heroId) return;
    var act = activeSlide(gallery);
    // Wenn das aktive Bild eine Materialkachel ist (z. B. Varianten-Startbild),
    // auf das freigestellte Bild umschalten und erneut aufraeumen.
    if (!act || act.dataset.mediaId !== res.heroId) {
      if (!act || isMaterialSlide(act, res.valueNames)) {
        try { gallery.setActiveMedia(res.heroId, false); } catch (e) {}
        cleanGallery(gallery, pi);
      }
    }
  }

  function setupProductInfo(pi) {
    if (pi._heroInit) return;
    var gallery = pi.querySelector('media-gallery');
    if (!gallery) return;
    pi._heroInit = true;
    var overlay = ensureOverlay(gallery);
    setHero(gallery, pi);
    requestAnimationFrame(function () { if (!pi._heroLast) setHero(gallery, pi); });
    setTimeout(function () { if (!pi._heroLast) setHero(gallery, pi); }, 250);
    setTimeout(function () { if (!pi._heroLast) setHero(gallery, pi); }, 900);

    pi.addEventListener('change', function (e) {
      var input = e.target.closest ? e.target.closest('[data-value-name]') : null;
      if (!input || !pi.contains(input)) return;
      applyHero(pi, gallery, overlay, input);
    });

    gallery.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('.thumbnail')) {
        hideOverlay(overlay);
        pi._heroLast = null;
      }
    });

    try {
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        subscribe(PUB_SUB_EVENTS.variantChange, function () {
          revealActive(gallery);
          cleanGallery(gallery, pi);
          if (!pi._heroLast) { setHero(gallery, pi); return; }
          if (pi._heroLast.type === 'media') {
            try { gallery.setActiveMedia(pi._heroLast.mediaId, false); } catch (e) {}
            revealActive(gallery);
          } else if (pi._heroLast.type === 'overlay' && !overlay.hidden) {
            syncHeight(gallery, overlay);
          }
        });
      }
    } catch (e) {}

    window.addEventListener('resize', function () {
      if (!overlay.hidden) syncHeight(gallery, overlay);
    });
  }

  function init() {
    injectStyle();
    document.querySelectorAll('product-info').forEach(setupProductInfo);
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('product-info:loaded', init);
})();
